<template>
  <div>
    <side-bar />
    <div class="relative md:ml-64 bg-main">
      <Header />
      <div class="px-4 md:px-10  mx-auto w-full pt-24 pb-12 overflow-y-auto h-full">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
import SideBar from '@/components/Layout/SideBar';
import Header from '@/components/Layout/Header';

export default {
  name: 'Layout',
  components: { SideBar, Header },
};
</script>

<style scoped>
  .bg-main{
    background: linear-gradient(190deg, rgba(43, 108, 176,1) 30%, #FFF 70%);
    height: 100vh;
    overflow: hidden;
  }
</style>



// WEBPACK FOOTER //
// src/components/Layout/Layout.vue